/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { taxPayment } from '@/api/ajax';
export default [
  {
    id: 'fws',
    key: 'selectBoxName',
    tip: '请输入服务商名称',
    required: false,
    slot: 'ajaxSelect',
    clearable: true,
    ajax: taxPayment.selectBox,
    prop: {
      label: 'enterpriseName',
      code: 'enterpriseName'
    },
    ajaxQuery: 'keyWord',
    width: 180
  },
  {
    width: 180,
    id: 'monthrange',
    tip: '请选择完税月份',
    key: 'proofMonth',
    required: false,
    slot: 'date',
    format: 'yyyy-MM',
    rangeValue: []
  }
];
